import { NavLink } from "react-router-dom";
import { Home, ListChecks, User, Wallet, Banknote } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export const EmployeeNav = () => {
  const { user } = useAuth();
  const isHourly = user?.pay_type === "hourly";

  const item = (to, Icon, label, tid) => (
    <NavLink
      to={to}
      end
      data-testid={tid}
      className={({ isActive }) =>
        `flex flex-1 flex-col items-center gap-1 py-2 text-[11px] font-medium transition-colors ${
          isActive ? "text-primary" : "text-zinc-500 hover:text-zinc-900"
        }`
      }
    >
      <Icon className="w-5 h-5" strokeWidth={2} />
      {label}
    </NavLink>
  );
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-zinc-200">
      <div className="max-w-md mx-auto flex">
        {item("/pegawai", Home, "Beranda", "nav-beranda")}
        {item("/pegawai/rekap", ListChecks, "Rekap", "nav-rekap")}
        {!isHourly && item("/pegawai/kasbon", Wallet, "Kasbon", "nav-kasbon")}
        {!isHourly && item("/pegawai/pinjaman", Banknote, "Pinjaman", "nav-pinjaman")}
        {isHourly && item("/pegawai/upah", Wallet, "Upah", "nav-upah")}
        {item("/pegawai/profil", User, "Profil", "nav-profil")}
      </div>
    </nav>
  );
};
